var m = require('mithril');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var addressInput = require('../components/inputs/addressInput');
var L = require('leaflet');

var Action = Object.assign(Object.create(Model), require('../../../../models/locations/Building'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


Action.editDialogue = function (record, parentRecord, options) {
  Model.initForm.call(Action, record)
  Action.form.parent(parentRecord['@rid'])
  
  if (record && record.geojson) {
    if (typeof record.geojson === 'object') {
      Action.form.geojson(JSON.stringify(record.geojson));
    } else {
      Action.form.geojson(record.geojson);
    }
  }
  
  Action.record = record ? record : undefined;

  var submit = async function () {
    let response = await Action.save()
    key.unbind('enter');
    if(options.map){
      if(response.latitude && response.longitude){
        var href = '/building/' + response['@rid'].slice(1)
        L.marker([response.latitude, response.longitude])
        .addTo(options.map)
        .bindPopup(
          `<a href=#!${href}>${response.name}</a>`
        )
      }
    }
    modal.vm.close();
    options && options.submitCallback ? await options.submitCallback() : '';
  };

  var deleteBuilding = function (){
    return Action.delete(Action.record)
    .then( response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      if(options.map){
        if(response.latitude && response.longitude){
          var href = '/building/' + response['@rid'].slice(1)
          L.marker([response.latitude, response.longitude])
          .addTo(options.map)
          .bindPopup(
            `<a href=#!${href}>${response.name}</a>`
          )
        }
      }
      modal.vm.close();
      m.redraw();
    })
  }

  var renderEditModal = function () {
    key.unbind('enter');
    key.setScope('modal');
    key('enter', 'modal', submit);

    modal.vm.title( Action.record ? 'Edit Building: ' : 'Add Building: ')
    modal.vm.body = Action.view,

    Action.record && options && options.delete ? 
      modal.vm.buttons([
        {
          label: "Delete",
          class: "dib red mr3 ",
          func: showDeleteConfirmation
        },
        {
          label: "Save",
          class: "dib",
          func: submit
        }
      ])
    :
      modal.vm.buttons([
        {
          label: "Save",
          class: "btn-good",
          func: submit
        }
      ]);
  };

  var showDeleteConfirmation = function () {
    key.unbind('enter');

    var confirmDelete = function () {
      return deleteBuilding();
    };

    key('enter', 'modal', confirmDelete);
    modal.vm.title(`Delete ${Action.record && Action.record.name ? Action.record.name : 'Building'}?`);
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Are you sure you want to delete this location?')
      ]);
    };
    modal.vm.buttons([
      {
        label: "Cancel",
        class: "dib mr2 ",
        func: function () {
          renderEditModal();
          modal.vm.open();
        }
      },
      {
        label: "Delete",
        class: "dib red ",
        func: confirmDelete
      }
    ]);
    modal.vm.open();
  };

  Action.initAutocomplite = function initAutocomplite(){
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('searchTextField'),{
        types:['establishment'],
        componentRestrictions: {'country': ['US']},
        fields: ['place_id', 'geometry', 'name']
      }
    )
  }

  renderEditModal();
  var modelOptions={
    extrawidth:true
  }
  modal.vm.open(modelOptions);
}

Action.counter = 0;

Action.view = function () {
  return m('form', {role:'form'}, [
    Action.errorView(),
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.name(ev.target.value),
      value: Action.form.name(),
    }),
    m('label', 'Default Map View:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.defaultMapView(ev.target.value),
      value: Action.form.defaultMapView(),
    }),
    m('label', 'Latitude:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.latitude(ev.target.value),
      value: Action.form.latitude(),
    }),  
    m('label', 'Longitude:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.longitude(ev.target.value),
      value: Action.form.longitude(),
    }),
    Action.record ? m('div', [
      m('label', 'GeoJson Data:'),
      m('textarea', {
        resize: 'none',
        rows:'5',
        cols:'40', 
        'box-sizing': 'border-box',
        placeholder:"Add GeoJson data here...",
        oninput: ev => Action.form.geojson(ev.target.value),
        value: Action.form.geojson()
      }),
      m('label', {for:'comment'}, 'Map SVG:'),
      m('textarea', {
        resize: 'none',
        rows:'5',
        cols:'40', 
        'box-sizing': 'border-box',
        placeholder:"Add Map SVG data here...",
        oninput: ev => Action.form.svg(ev.target.value),
        value: Action.form.svg()
      })
    ]) : ''
  ])
}




module.exports = Action;
